module.exports = __webpack_public_path__ + "img/laundry-service.19c40a05.jpeg";